import { render, staticRenderFns } from "./xapomarketsPool.vue?vue&type=template&id=576782e1&scoped=true&"
var script = {}
import style0 from "./xapomarketsPool.vue?vue&type=style&index=0&id=576782e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576782e1",
  null
  
)

export default component.exports